// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"212":"b661bb8d8cd24ca7","625":"9567c48b80bc4af3"}[chunkId] + ".css";
};